import "./ReportingChip.scss";

export const ReportingChip = ({ name, value }: { name: string, value: string }) => {
  return <div className="chip"><span>{name}: </span>{value}</div>;
};
